import React, { FC, useState } from "react";
import { Button, Flex, Icon } from "@telia/teddy";
import { useLocation } from "react-router-dom";
import { RETAILER_BASE_URL } from "../../../../../../constants/pages";
import SendFeedbackPanel from "../SendFeedbackPanel/SendFeedbackPanel";
import LoginHelpModal from "./LoginHelpModal";
import "./SupportLinks.less";

const SupportLinks: FC = () => {
    const location = useLocation();
    const [isReportErrorOpen, setIsReportErrorOpen] = useState(false);
    const [isLoginHelpOpen, setIsLoginHelpOpen] = useState(false);
    const normalizedPath =
        location.pathname.endsWith("/") && location.pathname !== "/"
            ? location.pathname.slice(0, -1)
            : location.pathname;
    const isLoginPage = normalizedPath === RETAILER_BASE_URL;

    return (
        <>
            <Flex direction="column" gap="200" mt="600" className="support-links">
                {isLoginPage && (
                    <Button variant="text" className="support-links__button" onClick={() => setIsLoginHelpOpen(true)}>
                        <Icon name="end-user" aria-hidden="true" focusable="false" />
                        Innloggingshjelp
                    </Button>
                )}
                <Button variant="text" className="support-links__button" onClick={() => setIsReportErrorOpen(true)}>
                    <Icon name="send" aria-hidden="true" focusable="false" />
                    Gi tilbakemelding
                </Button>
            </Flex>
            <LoginHelpModal open={isLoginHelpOpen} onClose={() => setIsLoginHelpOpen(false)} />
            <SendFeedbackPanel open={isReportErrorOpen} onOpenChange={setIsReportErrorOpen} />
        </>
    );
};

export default SupportLinks;
